import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-top-footer',
  templateUrl: './top-footer.component.html',
  styleUrls: ['./top-footer.component.scss']
})
export class TopFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
